import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

function AccessDeniedPage({ showLogout }) {
    return (
        <AuthWrapper heading="Access denied">
            <section className="sten-content__section">
                <p>We are sorry, but you don&apos;t have permissions to view this page.</p>
            </section>
            {showLogout && (
                <React.Fragment>
                    <div className="sten-content__separator" />
                    <section className="sten-content__section">
                        <a
                            className="btn btn--secondary btn--sm col-24"
                            href="/Account/Logout"
                        >
                            Logout
                        </a>
                    </section>
                </React.Fragment>
            )}
        </AuthWrapper>
    );
}

AccessDeniedPage.propTypes = {
    tenantInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    showLogout: PropTypes.bool
};

// Defaults to true so any other caller of this page keeps the existing behaviour. Only the
// TMM denial (an already signed-in user who simply lacks access to that one client) hides it,
// because logging them out of their valid Orbit session would be the wrong response.
AccessDeniedPage.defaultProps = {
    showLogout: true
};

export default AccessDeniedPage;
